import { fetchWithAuth } from '@omni/kit/utilities/utilities';

const debug = require('debug')('omni:messaging:service:userService');

export type ChatUserInfoObject = {
  appId: string;
  canCreateChannels: boolean;
  canCreateDirectMessage: boolean;
  endUserId: Uuid;
  userId: Uuid;
  userToken: string;
};

export const userService = {
  getChatUserInfo,
};

function getChatUserInfo(
  appKey: string,
  _accessToken: string,
  endpointUrl: string
): Promise<ChatUserInfoObject> {
  if (!appKey) {
    return Promise.reject('No appKey provided');
  }

  const headers = {
    'Content-Type': 'application/json',
    'sap-active-appkey': appKey,
  };
  const requestOptions = { headers, method: 'POST' };

  return fetchWithAuth(endpointUrl, requestOptions).then(handleResponse);
}

function handleResponse(response: Response): Promise<ChatUserInfoObject> {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      debug(`Auth failed: ${response.status}`, data);

      return Promise.reject(response);
    }

    debug('Auth success');

    return Promise.resolve({
      appId: data._embedded['chat-app'].chat_client_app_id,
      canCreateChannels: data._embedded['chat-user'].channel_admin,
      canCreateDirectMessage:
        data._embedded['chat-app'].direct_messages_enabled,
      endUserId: data._embedded['chat-user']._embedded['end-user'].id,
      userId: data._embedded['chat-user'].id,
      userToken: data._embedded['chat-token'].token,
    });
  });
}
